import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import splitDux from 'src/redux/split';
import macheteDux from 'src/redux/machete';
import SplitSlider from './SplitSlider';
import DeleteSplit from './DeleteSplit';
import SliderEditorButtons from './SliderEditorButtons';

import {
  HeaderContainer,
  NumberOfSplitFacesText,
  SplitFacesText,
  SplitSidebarContainer,
} from './styled';

const mapStateToProps = (state) => ({
  isDeletingSplit: splitDux.selectors.isDeletingSplit(state),
  confirmDisabled: splitDux.selectors.isSplitConfirmDisabled(state),
  selectedElementCount: macheteDux.selectors.getSelectedElementCount(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleConfirmDeleteSplit: splitDux.actions.handleConfirmDeleteSplit,
      handleCancelDeleteSplit: splitDux.actions.handleCancelDeleteSplit,
      handleSplitToolCancelSplit: splitDux.actions.handleSplitToolCancelSplit,
      handleSplitToolConfirmSplit: splitDux.actions.handleSplitToolConfirmSplit,
    },
    dispatch,
  );

export class SplitSidebar extends PureComponent {
  static propTypes = {
    confirmDisabled: PropTypes.bool.isRequired,
    handleConfirmDeleteSplit: PropTypes.func.isRequired,
    handleCancelDeleteSplit: PropTypes.func.isRequired,
    handleSplitToolCancelSplit: PropTypes.func.isRequired,
    handleSplitToolConfirmSplit: PropTypes.func.isRequired,
    isDeletingSplit: PropTypes.bool.isRequired,
    selectedElementCount: PropTypes.number.isRequired,
  };

  render() {
    const {
      confirmDisabled,
      handleConfirmDeleteSplit,
      handleCancelDeleteSplit,
      handleSplitToolCancelSplit,
      handleSplitToolConfirmSplit,
      isDeletingSplit,
      selectedElementCount,
    } = this.props;
    return (
      <SplitSidebarContainer data-selenium="splitSidebar">
        <HeaderContainer>
          <SplitFacesText>Split Faces</SplitFacesText>
          <NumberOfSplitFacesText>
            {selectedElementCount}
          </NumberOfSplitFacesText>
        </HeaderContainer>
        {!isDeletingSplit ? <SplitSlider /> : <DeleteSplit />}
        <SliderEditorButtons
          handleCancel={
            !isDeletingSplit
              ? handleSplitToolCancelSplit
              : handleCancelDeleteSplit
          }
          handleConfirm={
            !isDeletingSplit
              ? handleSplitToolConfirmSplit
              : handleConfirmDeleteSplit
          }
          confirmDisabled={confirmDisabled}
        />
      </SplitSidebarContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SplitSidebar);
